<template>
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <div class="surveylist" v-for="item in askList" :key="item.id">
      <router-link :to="{path:'/forum/edit3?id=4',query:{id: item.id,title: '投票调研'}}">
        <p>{{ item.title }}</p>
        <p class="ellipsis2">
          {{ item.description }}
        </p>
        <div class="surveylist-t">
          <p>{{ item.end_time }}</p>
          <p v-if="item.status===2">已截止</p>
          <p v-else>调研中</p>
        </div>
      </router-link>
    </div>
  </van-list>
</template>
<script setup>
import { ref } from "vue";
import ajax from "@/utils/request.js";
// import {useRoute} from "vue-router";

// const route = useRoute();
// const {query} = route;

const askList = ref([]);

const page = ref(1);
const loading = ref(false);
const finished = ref(false);

function getAskList() {
  loading.value = true;
  const data = {
    typeid: 5,
    page: page.value,
  };
  return ajax.post("users/getforumlist", data).then((res) => {
    if (res.data.length < 10) {
      askList.value = askList.value.concat(res.data);
      finished.value = true;
    } else {
        askList.value = askList.value.concat(res.data);
      page.value++;
    }
  }).catch(()=>{
    finished.value = true;
  });
}
getAskList().finally(() => {
  loading.value = false;
});

const onLoad = () => {
  getAskList().finally(() => {
  loading.value = false;
});
}
</script>
<style scoped>
.surveylist {
  background-color: #fff;
  padding: 4.2667vw 4vw;
}
.surveylist p:first-child {
  font-size: 14px;
  color: #333333;
}
.surveylist p:nth-child(2) {
  color: #666666;
  font-size: 14px;
  margin-top: 3.4667vw;
}
.surveylist-t {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4.2667vw;
}
.surveylist-t p:first-child {
  font-size: 14px;
  color: #999999;
}
.surveylist-t p:last-child {
  font-size: 16px;
  padding: 1.8667vw 7.4667vw;
  background-color: #f6f6f6;
  color: #666666;
  border-radius: 4.8vw;
}
</style>